/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useBatchEligibilityRequestHistory
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import _ from 'lodash';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';
import { BATCH_HISTORY_ADF_FIELD_MAP } from 'utils/adfUtils';

/**
 * Paginated Batch Eligibility Requests History
 * @returns {UseQueryResult} useBatchEligibilityRequestHistory
 */
const useBatchEligibilityRequestHistory = (
	queryModel: EligibilityBatchUpload.IBatchEligibilityHistoryQueryModel,
	pageNumber?: number,
	pageSize?: number,
	options?: IQueryOptions,
): UseQueryResult<EligibilityBatchUpload.IBatchEligibilityRequests, unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.batchEligibilityRequest, { queryModel, pageNumber, pageSize }],
		queryFn: async () => {
			const { data } = await api.EzapiApi.getBatchEligibilityRequests({
				batchEligibilityHistoryQueryModel: updateApiParamsCriteria(_.cloneDeep(queryModel), BATCH_HISTORY_ADF_FIELD_MAP),
				pgNum: pageNumber,
				pgSize: pageSize,
			});
			return data;
		},
		refetchInterval: 1000 * 60 * 2, // 2 mins,
		...options,
	});
};

export default useBatchEligibilityRequestHistory;
